<p-panelMenu [model]="itemsMenu" class='kanzi-menu-right'></p-panelMenu>

